module.exports = __webpack_public_path__ + "static/headshot-index-66995d81c1a9fad576301465ca40cd19.jpg";